import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface PreStageRuleConfirmationDialogProps {
  open: boolean;
  message: string;
  isSubmitting: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export function PreStageRuleConfirmationDialog({
  open,
  message,
  isSubmitting,
  onAccept,
  onDecline,
}: PreStageRuleConfirmationDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-warning-500" />
            Approval Rule Notice
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground">
            A pre-stage rule has generated the following message. Please review
            and choose whether to proceed with submission.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="rounded-lg border border-border bg-muted/50 p-4 my-2">
          <p className="text-sm">{message}</p>
        </div>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={onDecline}
            disabled={isSubmitting}
          >
            Decline
          </Button>
          <Button onClick={onAccept} disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Accept'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
